module.exports = __webpack_public_path__ + "static/media/My Rhapsody Sounds.133994f2.jpg";